import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'react-feather';
const ManagerOuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: transparent; /* Handled by GlobalStyles on body, but can set just in case: */
  overflow-x: hidden;
  max-width: 100vw;
`;

const ManagerScrollContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 5px; /* Consistent top padding for all pages */
  padding-bottom: 110px; /* Adjusted for taller navbar (80px + safe area) */
  background-color: transparent;
  height: 100dvh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  @media (min-width: 1024px) {
    padding-bottom: 20px;
  }
`;

const ContentWrapper = styled.div`
  max-width: 1000px;
  width: 90%;
  margin: 0 auto;
`;

const PageHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 30px;
  padding: 0 20px;
  position: relative;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${p => p.theme.colors.text.secondary};
  cursor: pointer;
  padding: 0;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  &:hover {
    color: ${p => p.theme.colors.text.primary};
  }
`;

const PageTitle = styled.h2`
  font-size: 32px;
  font-weight: 800;
  color: ${p => p.theme.colors.text.primary};
  margin: 0;
  text-align: left;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 8px;
  }
`;

const Footer = styled.div`
  padding: 20px;
  background-color: transparent;
  width: 100%;
  margin-top: auto;
  padding-bottom: calc(20px + env(safe-area-inset-bottom));
  display: flex;
  gap: 15px;
`;

const PageTemplate = ({
  title,
  children,
  showBackButton = true,
  onBack,
  footerActions
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo(0, 0);
    }
    window.scrollTo(0, 0);
  }, [pathname]);

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <ManagerOuterContainer>
      <ManagerScrollContainer ref={scrollRef}>
        <ContentWrapper>
          <div style={{ flex: 1, padding: 0, display: 'flex', flexDirection: 'column' }}>
            <PageHeader>
              {showBackButton && (
                <BackButton onClick={handleBack}>
                  <ArrowLeft size={16} /> Back
                </BackButton>
              )}
              <PageTitle>{title}</PageTitle>
            </PageHeader>
            {children}
          </div>
          {footerActions && (
            <Footer>
              {footerActions}
            </Footer>
          )}
        </ContentWrapper>
      </ManagerScrollContainer>
    </ManagerOuterContainer>
  );
};

export default PageTemplate;
